import React from 'react';
import Header from '../components/Header';
import Features from '../components/Features';
import Footer from '../components/Founders';

const Home = () => {
  return (
    <>
        <Header />
        <Features />
        <Footer />
    </>
  );
};

export default Home;
